import { useMemo } from "react";
import { Typography } from "@mui/material";
// import PsychologyAltOutlinedIcon from '@mui/icons-material/PsychologyAltOutlined';
import { useTranslation } from "react-i18next";

const suggestionMetricMapES = {
  clarity: "Claridad",
  relevance: "Relevancia",
  fluency: "Fluidez",
  engagement: "Conexión",
  objective_achievement: "Logro del Objetivo",
  all_low: "Mejora General",
  all_high: "Nuevo Desafío",
  no_clear_suggestion: "Exploración"
};

const suggestionMetricMapEN = {
  clarity: "Clarity",
  relevance: "Relevance",
  fluency: "Fluency",
  engagement: "Engagement",
  objective_achievement: "Goal Achievement",
  all_low: "Overall Performance",
  all_high: "A new challenge",
  no_clear_suggestion: "Exploration"
};

const genericSuggestions = ["all_low", "all_high", "no_clear_suggestion"];

const CoachSuggestionText = ({ suggestedMetric }) => {
  const { t, i18n } = useTranslation("coach_suggestion");
  const isES = i18n.language?.startsWith("es");
  const suggestionMap = isES ? suggestionMetricMapES : suggestionMetricMapEN;

  const suggestionsArray = useMemo(() => {
    if (!suggestedMetric) return [];
    return t(`metrics.${suggestedMetric}`, { returnObjects: true }) || [];
  }, [suggestedMetric, i18n.language]);

  const suggestionIndex = useMemo(() => {
    return suggestionsArray.length > 0
      ? Math.floor(Math.random() * suggestionsArray.length)
      : 0;
  }, [suggestionsArray]);

  const coachSuggestionText = suggestionsArray[suggestionIndex] || "";

  const metricText = suggestionMap[suggestedMetric];
  let header = "";
  if (metricText) {
    header = genericSuggestions.includes(suggestedMetric)
      ? (isES ? metricText : metricText.charAt(0).toUpperCase() + metricText.slice(1))
      : (isES ? `Mejora en ${metricText}` : `Improving ${metricText}`);
  }

  if (!coachSuggestionText) return null;

  return (
    <>
      {/* <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ display: "flex", alignItems: "center", gap: 0.5, color: "#a855f7", mb: 0, py: 0 }}
      >
        <PsychologyAltOutlinedIcon fontSize="small" sx={{ color: "#a855f7", mb: 0, py: 0 }} />
        {t("coach_suggestion_title")}
      </Typography> */}

      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 0 }}>
        {header}
      </Typography>

      <Typography variant="body2">
        {coachSuggestionText}
      </Typography>
    </>
  );
};

export default CoachSuggestionText;
